import Vue from "vue";
import Router from "vue-router";
import store from "./store";

const GetStarted = () =>
  import(/* webpackChunkName: "login" */ "./views/GetStarted.vue");
const CampaignLinker = () =>
  import(/* webpackChunkName: "tool" */ "./views/CampaignLinker.vue");
const Spaces = () =>
  import(/* webpackChunkName: "tool-index" */ "./views/Spaces.vue");
const Space = () => import(/* webpackChunkName: "space" */ "./views/Space.vue");
const Campaign = () =>
  import(/* webpackChunkName: "campaigns" */ "./views/Campaign.vue");
const Campaigns = () =>
  import(/* webpackChunkName: "campaigns" */ "./views/Campaigns.vue");
const QueryMap = () =>
  import(/* webpackChunkName: "admin" */ "./views/QueryMap.vue");
const Fields = () =>
  import(/* webpackChunkName: "admin" */ "./views/Fields.vue");
const Field = () => import(/* webpackChunkName: "admin" */ "./views/Field.vue");
const Settings = () =>
  import(/* webpackChunkName: "settings" */ "./views/Settings.vue");
const SuperAdmin = () =>
  import(/* webpackChunkName: "admin" */ "./views/SuperAdmin.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "get-started",
      component: GetStarted,
    },
    {
      path: "/oauth/callback",
      name: "callback",
      beforeEnter: (to, from, next) => {
        const type = "oauth/callback";
        const query = to.query;
        store
          .dispatch("fetchResource", {
            type,
            query,
          })
          .then(() => next("/spaces"))
          .catch(() => next("/"));
      },
    },
    {
      path: "/admin",
      component: CampaignLinker,
      meta: { requiresAdmin: true },
      children: [
        {
          path: "",
          component: SuperAdmin,
        },
      ],
    },
    {
      path: "/spaces",
      component: CampaignLinker,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          component: Spaces,
        },
        {
          path: ":space_id",
          component: Space,
          props: true,
          children: [
            {
              path: "",
              name: "space",
              redirect: "campaigns",
            },
            {
              path: "campaigns",
              name: "campaigns",
              component: Campaigns,
            },
            {
              path: "campaigns/:id",
              name: "campaign",
              component: Campaign,
              props: true,
            },
            {
              path: "fields",
              name: "fields",
              component: Fields,
              meta: { requiresAdmin: true },
            },
            {
              path: "fields/:id",
              name: "field",
              component: Field,
              props: true,
              meta: { requiresAdmin: true },
            },
            {
              path: "set",
              name: "set",
              component: QueryMap,
              meta: { requiresAdmin: true },
            },
            {
              path: "settings",
              name: "settings",
              component: Settings,
              meta: { requiresAdmin: true },
            },
          ],
        },
      ],
    },
    {
      path: "/invites/:id",
      name: "invites",
      beforeEnter: async (to, from, next) => {
        store.dispatch("authorize", to.params.id).catch(() => {
          next("/");
        });
      },
    },
    {
      path: "/*",
      redirect: "/",
    },
  ],
});

export default router;
